import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import TopSection from "../../LT/TopSection";
import { ExtractForecastFromSAP } from "./ExtractForecastFromSAP";
import ScheduleJobs from "./ScheduleJobs";

const ExtractForcastPage = () => {
  const [activeTab, setActiveTab] = useState(0);
 

  return (
    <Box sx={{ px: 2, pt: 0, pb: 4 }}>
      <TopSection
        labelList={[
          { title: "Home", path: "/forecastCollabPage" },
          { title: "Run Forecast Extraction" },
        ]}
        tabTitle="Run Forecast Extraction"
        hideTitle
      />

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{
            "& .MuiTab-root": { textTransform: "none", fontWeight: 500, fontSize: 14 },
            "& .Mui-selected": { color: "#000 !important" },
            "& .MuiTabs-indicator": { backgroundColor: "#000" },
          }}
        >
          <Tab label="Run Forecast Extraction" />
          <Tab label="Scheduled Job" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <ExtractForecastFromSAP />
      )}
      {activeTab === 1 && (
        <>
          <ScheduleJobs />
        </>
      )}
    </Box>
  );
};

export default ExtractForcastPage;